import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ActionButton from "./ActionButton";
import { useTranslation } from "react-i18next";
import { useModal } from "@pulse/hooks/contextHooks";
import { useQuery } from "@tanstack/react-query";
import { getSurveyOptions } from "@pulse/api/queryApi";
import { ParticipantsForm } from "@pulse/features/Edit/AddParticipants/Participant";
import { faUserPlus } from "@fortawesome/pro-regular-svg-icons";

export default function InviteMoreParticipants({ surveyId }: { surveyId: number }) {
    const { t } = useTranslation();
    const { openModal } = useModal();
    const { data: survey } = useQuery(getSurveyOptions({ surveyId }));
    return (
        <ActionButton
            onClick={() =>
                openModal({
                    title: t("responseOverview.inviteMoreParticipants"),
                    children: survey ? <ParticipantsForm survey={survey} /> : null,
                })
            }
            label={t("responseOverview.labelInviteMore")}
        >
            <FontAwesomeIcon icon={faUserPlus} size="xl" className="scale-90" />
        </ActionButton>
    );
}
